var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 457 457.147",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.715 1.273c-2.785-1.664-6.23-1.687-9.07-.125L301.789 79.645 159.914 1.172a9.1 9.1 0 0 0-8.84-.024L4.79 82.094a9.129 9.129 0 0 0-4.715 8v357.91a9.142 9.142 0 0 0 4.5 7.875 9.092 9.092 0 0 0 4.64 1.27 9.207 9.207 0 0 0 4.43-1.145l141.86-78.496 141.855 78.496a9.207 9.207 0 0 0 4.43 1.144c1.524 0 3.04-.41 4.41-1.171l146.305-80.918a9.134 9.134 0 0 0 4.71-8V9.149a9.138 9.138 0 0 0-4.5-7.876zM146.359 361.664l-128 70.832V95.484l128-70.828zm146.286 70.832-128-70.828V24.656l128 70.828zm146.285-70.832-128 70.828V95.484l128-70.828zm0 0",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapview);
export default __webpack_public_path__ + "static/media/mapview.702119b3.svg";
export { ForwardRef as ReactComponent };